import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import FeedbackDialog from "../components/FeedbackDialog";
import { api, apiErr } from "../lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import NotesTab from "./chapter/NotesTab";
import ChatTab from "./chapter/ChatTab";
import QuizTab from "./chapter/QuizTab";
import SamplePapersTab from "./chapter/SamplePapersTab";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Chapter() {
  const { cls, subject, chapterId } = useParams();
  const nav = useNavigate();
  const [chapter, setChapter] = useState(null);

  useEffect(() => {
    api.get(`/syllabus/${cls}/${subject}`).then((r) => {
      setChapter(r.data.find((c) => c.id === chapterId));
    });
  }, [cls, subject, chapterId]);

  return (
    <div className="min-h-screen">
      <Header />
      <FeedbackDialog />
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6">
        <Button onClick={() => nav("/dashboard")} data-testid="back-to-dashboard"
          className="brut-btn rounded-none bg-white hover:bg-white text-black mb-4">
          <ArrowLeft size={16} className="mr-1" strokeWidth={2.5}/> Back
        </Button>

        <div className="brut-card p-6 bg-[#E9E6FA] mb-6">
          <div className="text-xs font-bold tracking-[0.2em] uppercase">
            Class {cls} • {subject === "physics" ? "Physics" : "Chemistry"} • Chapter {chapter?.num}
          </div>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight mt-1">{chapter?.title || "Loading…"}</h1>
          {chapter && (
            <p className="mt-2 text-sm text-neutral-800">{chapter.topics.join(" • ")}</p>
          )}
        </div>

        <Tabs defaultValue="notes" className="w-full">
          <TabsList className="w-full grid grid-cols-4 h-auto p-1 bg-white brut-border brut-shadow-sm rounded-none">
            {[
              { v: "notes", l: "Notes" },
              { v: "chat", l: "Chat" },
              { v: "quiz", l: "Quiz" },
              { v: "papers", l: "Board Papers" },
            ].map((t) => (
              <TabsTrigger key={t.v} value={t.v} data-testid={`tab-${t.v}`}
                className="rounded-none py-3 font-bold data-[state=active]:bg-[#FFB3BA] data-[state=active]:shadow-none">
                {t.l}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value="notes"><NotesTab cls={cls} subject={subject} chapterId={chapterId}/></TabsContent>
          <TabsContent value="chat"><ChatTab cls={cls} subject={subject} chapter={chapter}/></TabsContent>
          <TabsContent value="quiz"><QuizTab cls={cls} subject={subject} chapterId={chapterId}/></TabsContent>
          <TabsContent value="papers"><SamplePapersTab cls={cls} subject={subject} chapterId={chapterId}/></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
